import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appContainerSelector]',
})
export class ContainerSelectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
